import {Pipe, PipeTransform} from '@angular/core';
import {PermissionType} from "@services";
import {capitalCase} from 'change-case';

@Pipe({
    name: 'permissionType',
    standalone: true
})
export class PermissionTypePipe implements PipeTransform {
    transform(value: PermissionType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case PermissionType.DashboardMyScore: return "My Score";
            case PermissionType.HrApprovalInformationChange: return "HR Approval Information Change";
            case PermissionType.Checklist: return "MHE Checklist";
            case PermissionType.ChecklistRepair: return "MHE Repair";
            case PermissionType.ChecklistCompliance: return "MHE Compliance";
            case PermissionType.ChecklistCondition: return "MHE Status";
            case PermissionType.IncidentReportApproval: return "Incident Report Approvals";
            case PermissionType.IncidentReports: return "My Score: Incident Reports";
            case PermissionType.InventoryMaterials: return "Materials";
            case PermissionType.InventoryBins: return "Storage Bins";
            case PermissionType.InventoryHALB: return "HALB";
            case PermissionType.InventoryStorageUnits: return "Storage Units";
            case PermissionType.InventoryFacilityUtilization: return "Facility Utilization";
            case PermissionType.InventoryStorageUnits210: return "210 Damaged";
            case PermissionType.InventoryStorageUnits216: return "216 Missing";
            case PermissionType.InventoryStorageUnits260: return "260 Putaway";
            case PermissionType.InventoryStorageUnits999: return "999 Cycle Count";
            case PermissionType.InventoryStorageUnitsLT22: return "LT22 Refill";
            case PermissionType.SLA: return "SLA";
            case PermissionType.ImportEmployees: return "Employees";
            case PermissionType.ImportVacations: return "Vacations";
            case PermissionType.ImportMaterials: return "Materials";
            case PermissionType.ImportBins: return "Storage Bins";
            case PermissionType.ImportHALB: return "HALB";
            case PermissionType.ImportStorageUnits: return "Storage Units";
            case PermissionType.ImportStorageUnits210: return "210 (Damaged)";
            case PermissionType.ImportStorageUnits216: return "216 (Missing)";
            case PermissionType.ImportStorageUnits260: return "260 (Putaway)";
            case PermissionType.ImportStorageUnits999: return "999 (Cycle Count)";
            case PermissionType.ImportStorageUnitsLT22: return "LT22 Refill";
            case PermissionType.ImportPurchaseOrders: return "Purchase Orders";
            case PermissionType.ImportBlockedStock: return "Blocked Stock";
            case PermissionType.ImportMB51: return "MB51";
            case PermissionType.ImportNextView: return "Next View";
            case PermissionType.ImportYearToDate: return "Year To Date";
            case PermissionType.ImportOrders: return "Orders";
            case PermissionType.ImportTmReport: return "TM Report";
            case PermissionType.ImportGlCodes: return "GL Codes";
            case PermissionType.Appointments: return "Appointments";
            case PermissionType.AppointmentDetails: return "Section: Details";
            case PermissionType.AppointmentGuardHouse: return "Section: Guard House";
            case PermissionType.AppointmentCompliance: return "Section: Compliance";
            case PermissionType.AppointmentSubmit: return "Action: Submit";
            case PermissionType.AppointmentApprove: return "Action: Approve";
            case PermissionType.AppointmentDecline: return "Action: Decline";
            case PermissionType.AppointmentSendBack: return "Action: Send Back";
            case PermissionType.AppointmentNoShow: return "Action: No Show";
            case PermissionType.AppointmentCheckIn: return "Action: Check In";
            case PermissionType.AppointmentShuntMove: return "Action: Shunt Move";
            case PermissionType.AppointmentCompleteMove: return "Action: Complete Move";
            case PermissionType.AppointmentTagsAsnPgiRequired: return "Action: Request Tags/ASN/PGI";
            case PermissionType.AppointmentTagsAsnPgiConfirmed: return "Action: Tags/ASN/PGI Confirmed";
            case PermissionType.AppointmentInvestigate: return "Action: Investigate";
            case PermissionType.AppointmentInvestigationCompleted: return "Action: Investigation Completed";
            case PermissionType.AppointmentRefuseLoad: return "Action: Refuse Load";
            case PermissionType.AppointmentAcceptLoad: return "Action: Accept Load";
            case PermissionType.AppointmentAssignToUnload: return "Action: Assign To Unload";
            case PermissionType.AppointmentComplete: return "Action: Complete";
            case PermissionType.AppointmentCheckOut: return "Action: Check Out";
            case PermissionType.AppointmentCalendar: return "Calendar";
            case PermissionType.AppointmentAgingScore: return "My Score: Appointment Aging";
            case PermissionType.InboundProductivityScore: return "My Score: Inbound Productivity";
            case PermissionType.TagsRequiredScore: return "My Score: Tags Required";
            case PermissionType.AppointmentComplianceScore: return "My Score: Compliance %";
            case PermissionType.AppointmentSupplierComplianceScore: return "My Score: Supplier Compliance";
            case PermissionType.EmptyCheckIns: return "Empty Trailers";
            case PermissionType.EmptyCheckInDetails: return "Section: Details";
            case PermissionType.EmptyCheckInHistory: return "Section: History";
            case PermissionType.EmptyCheckInCheckIn: return "Action: Check-In";
            case PermissionType.EmptyCheckInNotRequired: return "Action: Not Required";
            case PermissionType.EmptyCheckInRequired: return "Action: Required";
            case PermissionType.EmptyCheckInShuntMove: return "Action: Shunt Move";
            case PermissionType.EmptyCheckInCompleteMove: return "Action: Complete Move";
            case PermissionType.EmptyCheckInInvestigate: return "Action: Investigate";
            case PermissionType.EmptyCheckInInvestigationCompleted: return "Action: Investigation Completed";
            case PermissionType.EmptyCheckInCheckOut: return "Action: Check-Out";
            case PermissionType.EmptyCheckInStartLoading: return "Action: Start Loading";
            case PermissionType.EmptyCheckInMarkAsLoaded: return "Action: Mark as Loaded";
            case PermissionType.EmptyCheckOuts: return "Check-Out";
            case PermissionType.EmptyCheckOutDetails: return "Section: Details";
            case PermissionType.EmptyCheckOutHistory: return "Section: History";
            case PermissionType.EmptyCheckOutShuntMove: return "Action: Shunt Move";
            case PermissionType.EmptyCheckOutCompleteMove: return "Action: Complete Move";
            case PermissionType.EmptyCheckOutInvestigate: return "Action: Investigate";
            case PermissionType.EmptyCheckOutInvestigationCompleted: return "Action: Investigation Completed";
            case PermissionType.EmptyCheckOutCheckOut: return "Action: Check-Out";
            case PermissionType.YardCapacityScore: return "My Score: Yard Capacity";
            case PermissionType.ShuntProductivityScore: return "My Score: Shunt Productivity";
            case PermissionType.EmptyTrailerAgingScore: return "My Score: Empty Trailer Aging";
            case PermissionType.ShuntManagement: return "Shunt Management Grid";
            case PermissionType.YardCapacity: return "Yard Capacity Grid";
            case PermissionType.Performance: return "Performance";
            case PermissionType.NextView: return "Efficiency";
            case PermissionType.DeleteProductivityReport: return "Delete Entries";
            case PermissionType.YearToDate: return "Year To Date";
            case PermissionType.MB51: return "MB51";
            case PermissionType.GlCodes: return "GL Codes";
            case PermissionType.GlCodesClients: return "GL Codes (Sites)";
            case PermissionType.ServiceTypes: return "Service Types";
            case PermissionType.InvoicePurchaseOrders: return "PO";
            case PermissionType.InvoicePurchaseOrderDetails: return "Section: Details";
            case PermissionType.InvoicePurchaseOrderHistory: return "Section: History";
            case PermissionType.InvoicePurchaseOrderGlCodes: return "Section: GL Codes";
            case PermissionType.InvoicePurchaseOrderNotes: return "Section: Notes";
            case PermissionType.InvoicePurchaseOrderInternalNotes: return "Section: Internal Notes";
            case PermissionType.InvoicePurchaseSubmit: return "Action: Submit";
            case PermissionType.InvoicePurchaseCancel: return "Action: Cancel PO";
            case PermissionType.Invoices: return "Invoice";
            case PermissionType.InvoiceDetails: return "Section: Details";
            case PermissionType.InvoiceHistory: return "Section: History";
            case PermissionType.InvoiceGlCodes: return "Section: GL Codes";
            case PermissionType.InvoiceNotes: return "Section: Notes";
            case PermissionType.InvoiceInternalNotes: return "Section: Internal Notes";
            case PermissionType.InvoiceSubmit: return "Action: Submit";
            case PermissionType.InvoiceApproveL1: return "Action: Approve L1";
            case PermissionType.InvoiceApproveL2: return "Action: Approve L2";
            case PermissionType.InvoiceApproveL3: return "Action: Approve L3";
            case PermissionType.InvoiceBackToVendor: return "Action: Back to Vendor";
            case PermissionType.InvoiceDecline: return "Action: Decline";
            case PermissionType.InvoiceInvestigate: return "Action: Investigate";
            case PermissionType.InvoiceInvestigationCompleted: return "Action: Investigation Completed";
            case PermissionType.InvoiceOnHold: return "Action: On Hold";
            case PermissionType.InvoiceResumeInvoice: return "Action: Resume Invoice";
            case PermissionType.InvoicePosted: return "Action: Posted";
            case PermissionType.InvoiceBackToL1: return "Action: Back to L1";
            case PermissionType.InvoiceUndoToPendingAP: return "Action: Undo to Pending AP";
            case PermissionType.ConversionRates: return "Conversion Rate";
            case PermissionType.MustDepartTimes: return "Must Depart Times";
            case PermissionType.CreditRequests: return "Credit Requests";
            case PermissionType.CreditRequestDetails: return "Section: Details";
            case PermissionType.CreditRequestHistory: return "Section: History";
            case PermissionType.CreditRequestGlCodes: return "Section: GL Codes";
            case PermissionType.CreditRequestNotes: return "Section: Notes";
            case PermissionType.CreditRequestInternalNotes: return "Section: Internal Notes";
            case PermissionType.CreditRequestSubmit: return "Action: Submit";
            case PermissionType.CreditRequestComplete: return "Action: Complete";
            case PermissionType.CreditRequestCancel: return "Action: Cancel";
            case PermissionType.CreditRequestBackToAP: return "Action: Back to AP";
            case PermissionType.MyScoreFinanceInvoices: return "My Score: Finance Invoices";
            case PermissionType.MyScoreCreditRequests: return "My Score: Credit Requests";
            case PermissionType.MyScoreOrderPlanningMix: return "My Score: Order Planning Mix";
            case PermissionType.MyScorePreProductionOrders: return "My Score: Pre-Production Orders";
            case PermissionType.MyScorePostProductionMdt: return "My Score: Post-Production MDT";
            case PermissionType.UserContactInformationOwn: return "User: Own Contact Information";
            case PermissionType.UserContactInformationOthers: return "User: Others' Contact Information";
            case PermissionType.UserAlternateNamesOwn: return "User: Own Alternate Name";
            case PermissionType.UserAlternateNamesOthers: return "User: Others' Alternate Name";
            case PermissionType.UserPasswordResetOwn: return "User: Own Password Reset";
            case PermissionType.UserPasswordResetOthers: return "User: Others' Password Reset";
            case PermissionType.UserNotesOwn: return "User: Own Notes";
            case PermissionType.UserNotesOthers: return "User: Others' Notes";
            case PermissionType.UserSecurityAndPermissionsOwn: return "User: Own Security & Permissions";
            case PermissionType.UserSecurityAndPermissionsOthers: return "User: Others' Security & Permissions";
            case PermissionType.UserProfileHistoryOwn: return "User: Own Profile History";
            case PermissionType.UserProfileHistoryOthers: return "User: Others' Profile History";
            case PermissionType.UserEmergencyDetailsOwn: return "User: Own Emergency Details";
            case PermissionType.UserEmergencyDetailsOthers: return "User: Others' Emergency Details";
            case PermissionType.Impersonate: return "User: Impersonate";
            case PermissionType.SendInvitationEmail: return "Action: Send Invitation Email";
            case PermissionType.DeactivateUser: return "Action: Deactivate User";
            case PermissionType.TerminateUser: return "Action: Terminate User";
            case PermissionType.ConfirmTermination: return "Action: Confirm Termination";
            case PermissionType.ConfirmDeactivation: return "Action: Confirm Deactivation";
            case PermissionType.DelimitPosition: return "Action: Delimit Position";
            case PermissionType.ActivateUser: return "Action: Activate User";
            case PermissionType.IssuePassword: return "Action: Issue Password";
            case PermissionType.EmployeeShiftDetailsOwn: return "Employee: Own Shift Details";
            case PermissionType.EmployeeShiftDetailsOthers: return "Employee: Others' Shift Details";
            case PermissionType.EmployeeFinancialDetailsOwn: return "Employee: Own Financial Details";
            case PermissionType.EmployeeFinancialDetailsOthers: return "Employee: Others' Financial Details";
            case PermissionType.EmployeeEmploymentDetailsOwn: return "Employee: Own Employment Details";
            case PermissionType.EmployeeEmploymentDetailsOthers: return "Employee: Others' Employment Details";
            case PermissionType.EmployeeNestleDetailsOwn: return "Employee: Own Nestle Details";
            case PermissionType.EmployeeNestleDetailsOthers: return "Employee: Others' Nestle Details";
            case PermissionType.ConfirmSapNestle: return "Action: Confirm SAP - Nestle";
            case PermissionType.ConfirmDwaNestle: return "Action: Confirm DWA - Nestle";
            case PermissionType.ConfirmDwaHopewell: return "Action: Confirm DWA - Hopewell";
            case PermissionType.ConfirmNextViewHopewell: return "Action: Confirm NextView - Hopewell";
            case PermissionType.ConfirmPasswordReset: return "Action: Confirm Password Reset";
            case PermissionType.UserSupplierDetailsOwn: return "Supplier: Own Details";
            case PermissionType.UserSupplierDetailsOthers: return "Supplier: Others' Details";
            case PermissionType.UserCarrierDetailsOwn: return "Carrier: Own Details";
            case PermissionType.UserCarrierDetailsOthers: return "Carrier: Others' Details";
            case PermissionType.UserVendorDetailsOwn: return "Vendor: Own Details";
            case PermissionType.UserVendorDetailsOthers: return "Vendor: Others' Details";
            case PermissionType.UserCustomerDetailsOwn: return "Customer: Own Details";
            case PermissionType.UserCustomerDetailsOthers: return "Customer: Others' Details";
            case PermissionType.UserSiteDetailsOwn: return "Site (Invoicing): Own Details";
            case PermissionType.UserSiteDetailsOthers: return "Site (Invoicing): Others' Details";
            case PermissionType.UserAgencyDetailsOwn: return "Agency: Own Details";
            case PermissionType.UserAgencyDetailsOthers: return "Agency: Others' Details";
            default: return capitalCase(value);
        }
    }
}

